import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { isNative, navigateTo } from './platform';

export async function initNativeShell() {
  if (!isNative) return;

  try {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#9B7B5B' });
  } catch {
    /* status bar not available on all devices */
  }

  try {
    await SplashScreen.hide();
  } catch {
    /* ignore */
  }

  App.addListener('appUrlOpen', (event) => {
    try {
      const url = new URL(event.url);
      const path = url.pathname + url.search;
      if (path && path !== '/') navigateTo(path);
    } catch {
      /* ignore malformed deep links */
    }
  });
}
